module.exports = __webpack_public_path__ + "img/yun.6d52f473.png";